<template>
  <li
    :class="{
      'selected': select.id == value,
      'hover': hover
    }"
    class="el-select-dropdown__item"
    @click.stop.prevent="handleClick"
    @mousedown.stop.prevent="selectOptionClick"
    @mouseenter="hoverItem"
  >
    <span>{{ label }}</span>
  </li>
</template>

<script>
  import Emitter from '../../mixins/emitter';

  export default {
    name: 'my-options',
    mixins: [Emitter],
    data() {
      return {
        hover: false
      };
    },
    inject: ['select'],
    computed: {
    },
    props: {
      value: {
        required: true,
        type: [String, Number]
      },
      label: [String, Number],
      item: Object
    },
    watch: {
      value() {
        // this.select.setSelected()
      }
    },
    created() {
      this.select.options.push(this);
      this.select.cachedOptions.push(this);
    },
    beforeDestroy() {
      this.select.onOptionDestroy(this.select.cachedOptions.indexOf(this));
    },
    methods: {
      hoverItem() {
        if (!this.disabled && !this.groupDisabled) {
          this.select.hoverIndex = this.select.options.indexOf(this);
        }
      },
      selectOptionClick(event) {
        // this.select.handleChoose(this, this.item)
        this.select.$nextTick(() => {
          this.dispatch('mySelect', 'handleChoose', [this, this.item]);
        });
      },
      handleClick(event) { }
    },
  };

</script>

<style scoped lang='scss'>
</style>



// WEBPACK FOOTER //
// src/components/select/li.vue